import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const getNotifications = createAsyncThunk(
  "GET/Notifications",
  async (id, page) => {
    try {
      const response = await instance.get(endpoints.getNotifications(id, page));
      console.log(response);

      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);

export const getNotificationDetail = createAsyncThunk(
  "GET/Notification/Detail",
  async (data) => {
    try {
      const response = await instance.get(
        endpoints.getNotificationDetail + `${data.id}/${data.userId}`
      );
      return response;
    } catch (error) {
      return {
        exception: error,
      };
    }
  }
);
